'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosSnowy = function IoIosSnowy(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm29.7 24.8c0.3 0.1 0.4 0.5 0.2 0.8s-0.5 0.4-0.8 0.3l-2.3-1.4c-0.2 0.7-0.2 1.3 0 1.9 0.1 0.3-0.2 0.7-0.5 0.8s-0.7-0.2-0.8-0.5c-0.1-0.9-0.2-1.9 0.1-2.8l-5-2.8v5.7c0.9 0.2 1.7 0.6 2.4 1.2 0.3 0.3 0.4 0.7 0.1 0.9s-0.6 0.3-0.8 0.1c-0.5-0.4-1-0.8-1.7-1v2.6c0 0.3-0.3 0.6-0.6 0.6s-0.6-0.3-0.6-0.6v-2.6c-0.6 0.2-1.2 0.6-1.7 1-0.2 0.2-0.6 0.1-0.8-0.1s-0.3-0.6 0-0.9c0.7-0.6 1.5-1 2.5-1.2v-5.7l-5.1 2.8c0.3 0.9 0.3 1.8 0.2 2.7-0.1 0.3-0.4 0.7-0.7 0.6s-0.7-0.5-0.6-0.8c0.2-0.6 0.2-1.2 0-1.9l-2.3 1.4c-0.3 0.1-0.7 0-0.8-0.3s-0.1-0.7 0.2-0.8l2.3-1.3c-0.5-0.5-1-0.8-1.7-1-0.3-0.1-0.4-0.5-0.4-0.8 0.2-0.3 0.5-0.5 0.8-0.4 1 0.3 1.7 0.9 2.4 1.5l5.1-2.8-5.1-2.9c-0.7 0.7-1.4 1.2-2.4 1.5-0.3 0.1-0.7 0-0.8-0.3s0.1-0.8 0.4-0.9c0.7-0.2 1.2-0.4 1.7-0.9l-2.3-1.3c-0.3-0.1-0.4-0.5-0.2-0.8s0.5-0.4 0.8-0.3l2.3 1.3c0.2-0.6 0.2-1.2 0-1.8-0.1-0.3 0.2-0.7 0.6-0.8s0.6 0.2 0.7 0.5c0.1 0.9 0 1.9-0.2 2.8l5.1 2.8v-5.7c-1-0.2-1.8-0.6-2.5-1.2-0.3-0.3-0.3-0.7 0-0.9s0.6-0.3 0.8-0.1c0.5 0.4 1.1 0.8 1.7 1v-2.6c0-0.3 0.3-0.6 0.6-0.6s0.6 0.3 0.6 0.6v2.6c0.7-0.2 1.2-0.6 1.7-1 0.2-0.2 0.6-0.1 0.8 0.1s0.2 0.6-0.1 0.9c-0.7 0.6-1.5 1-2.4 1.2v5.7l5-2.8c-0.2-0.9-0.3-1.9-0.1-2.8 0-0.3 0.4-0.6 0.8-0.5s0.5 0.5 0.4 0.8c-0.1 0.6-0.1 1.2 0.1 1.8l2.3-1.3c0.3-0.1 0.7 0 0.8 0.3s0.1 0.7-0.2 0.8l-2.3 1.3c0.5 0.4 1 0.8 1.7 1 0.3 0.1 0.4 0.5 0.4 0.8s-0.5 0.4-0.8 0.4c-1-0.3-1.8-0.8-2.4-1.5l-5 2.8 5 2.8c0.6-0.6 1.4-1.2 2.4-1.5 0.3-0.1 0.7 0.1 0.8 0.4s-0.1 0.7-0.4 0.8c-0.7 0.2-1.2 0.5-1.7 1z' })
        )
    );
};

exports.default = IoIosSnowy;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-snowy.js
// module id = 2521
// module chunks = 0